import Card from '../components/card/Card';
import Tooltip from '../components/tooltip/Tooltip';
import Span from '../components/texts/span/Span';
import P from '../components/texts/p/P';
import { formatCuit, formatCurrency, getResponsiveColumnWidth } from '../utils/Masks';
import { ApprovedApplicationsData } from '../types/interfaces';

export function getGuaranteesColumns() {
  return [
    {
      name: 'CUIT',
      selector: (row: ApprovedApplicationsData) => (
        <Card>
          <P type='3' variant='neutral'>
            {formatCuit(row?.cuit || '')}
          </P>
        </Card>
      ),
      width: getResponsiveColumnWidth('cuit'),
      minWidth: '140px',
    },
    {
      name: 'Razón social',
      selector: (row: ApprovedApplicationsData) => (
        <Card>
          <Tooltip position='top' msg={row?.company_name || ''}>
            <Span type='3' variant='neutral'>
              {row?.company_name && row.company_name.length > 35 
                ? `${row.company_name.substring(0, 35)}...` 
                : row?.company_name || ''}
            </Span>
          </Tooltip>
        </Card>
      ),
      width: getResponsiveColumnWidth('company'),
      minWidth: '200px',
      grow: 1,
    },
    {
      name: 'Referido',
      selector: (row: ApprovedApplicationsData) => (
        <Card>
          <P type='3' variant='neutral'>
            {row?.referred_name || 'Generación propia'}
          </P>
        </Card>
      ),
      width: getResponsiveColumnWidth('name'),
      minWidth: '150px',
    },
    {
      name: 'Líneas vigentes',
      selector: (row: ApprovedApplicationsData) => (
        <Card>
          <P type='3' variant='neutral'>
            {row?.approved_applications_count || 0}
          </P>
        </Card>
      ),
      width: getResponsiveColumnWidth('status'),
      minWidth: '120px',
      center: true,
    },
    {
      name: 'Total',
      cell: (row: ApprovedApplicationsData) => (
        <Card>
          <Card display='flex' gap='2px' margin={{ bottom: '1' }}>
            <P type='2' withMargin={false} variant='neutral' weight='bold'>
              ARS
            </P>
            <P type='2' withMargin={false} variant='neutral'>
              {formatCurrency(row.total_approved_amount_ars ?? 0, true)}
            </P>
          </Card>
          <Card display='flex' gap='2px'>
            <P type='2' withMargin={false} variant='neutral' weight='bold'>
              USD
            </P>
            <P type='2' withMargin={false} variant='neutral'>
              {formatCurrency(row.total_approved_amount_usd ?? 0, true)}
            </P>
          </Card>
        </Card>
      ),
      width: getResponsiveColumnWidth('amount'),
      minWidth: '160px',
    },
    {
      name: 'Utilizado',
      cell: (row: ApprovedApplicationsData) => (
        <Card>
          <Card display='flex' gap='2px' margin={{ bottom: '1' }}>
            <P type='2' withMargin={false} variant='neutral' weight='bold'>
              ARS
            </P>
            <P type='2' withMargin={false} variant='neutral'>
              {formatCurrency(row.used_amount_ars ?? 0, true)}
            </P>
          </Card>
          <Card display='flex' gap='2px'>
            <P type='2' withMargin={false} variant='neutral' weight='bold'>
              USD
            </P>
            <P type='2' withMargin={false} variant='neutral'>
              {formatCurrency(row.used_amount_usd ?? 0, true)}
            </P>
          </Card>
        </Card>
      ),
      width: getResponsiveColumnWidth('amount'),
      minWidth: '160px',
    },
    {
      name: 'Disponible',
      cell: (row: ApprovedApplicationsData) => (
        <Card>
          <Card display='flex' gap='2px' margin={{ bottom: '1' }}>
            <P type='2' withMargin={false} variant='neutral' weight='bold'>
              ARS
            </P>
            <P type='2' withMargin={false} variant='neutral'>
              {formatCurrency(row.available_amount_ars ?? 0, true)}
            </P>
          </Card>
          <Card display='flex' gap='2px'>
            <P type='2' withMargin={false} variant='neutral' weight='bold'>
              USD
            </P>
            <P type='2' withMargin={false} variant='neutral'>
              {formatCurrency(row.available_amount_usd ?? 0, true)}
            </P>
          </Card>
        </Card>
      ),
      width: getResponsiveColumnWidth('amount'),
      minWidth: '160px',
    },
  ];
}